import hboxDesigner from './hbox-designer'
import hboxEditor from './hbox-editor'

import vboxDesigner from './vbox-designer'
import vboxEditor from './vbox-editor'

let widgets=[
  {
    id:"widget-layout-hbox",
    xtype:"hbox",
    name:"列布局",
    builtIn:true,
    initData:{columns:[{width:"50%"},{width:"50%"}]},
    editorComp:hboxEditor,
    designerComp:hboxDesigner
  },
  {
    id:"widget-layout-vbox",
    xtype:"vbox",
    name:"行布局",
    builtIn:true,
    initData:{rows:[{height:"50%"},{height:"50%"}]},
    editorComp:vboxEditor,
    designerComp:vboxDesigner
  },
]
export default widgets;



// WEBPACK FOOTER //
// ./src/common/components/extend/layout/designer/widgets.js